(function () {
  const footer = document.querySelector(".site-footer");
  if (!footer) return;

  const scrollTopButton = footer.querySelector("[data-scroll-top]");
  scrollTopButton?.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
})();
